/* Page "Idées cadeaux" : filtres par tags + flèches des sliders.
   Chargé par les sections xmas-filters et xmas-product-slider (garde anti-double chargement). */
(function () {
  if (window.__xgGifts) return;
  window.__xgGifts = true;

  // Etat des filtres : { groupe: [tag, tag, ...] }
  // Règle : OU à l'intérieur d'un groupe, ET entre les groupes.
  var state = {};

  function toArray(list) {
    return Array.prototype.slice.call(list);
  }

  function activeGroups() {
    return Object.keys(state).filter(function (g) {
      return state[g].length > 0;
    });
  }

  function updateArrows(slider) {
    var track = slider.querySelector('[data-xg-track]');
    if (!track) return;
    var prev = slider.querySelector('[data-xg-prev]');
    var next = slider.querySelector('[data-xg-next]');
    var atStart = track.scrollLeft <= 1;
    var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
    if (prev) prev.disabled = atStart;
    if (next) next.disabled = atEnd;
    slider.classList.toggle('xg-no-scroll', atStart && atEnd);
  }

  // Centre les flèches verticalement sur l'image du produit (et non sur toute la carte).
  function layoutArrows(slider) {
    var selectors = ['a.x-labels-data', '.preview-img', 'img'];
    var sliderRect = slider.getBoundingClientRect();
    var mediaRect = null;
    for (var i = 0; i < selectors.length && !mediaRect; i++) {
      var found = slider.querySelectorAll('[data-xg-product]:not([hidden]) ' + selectors[i]);
      for (var j = 0; j < found.length; j++) {
        var rect = found[j].getBoundingClientRect();
        if (rect.height > 40) {
          mediaRect = rect;
          break;
        }
      }
    }
    if (!mediaRect) return;
    var top = mediaRect.top - sliderRect.top + mediaRect.height / 2;
    slider.style.setProperty('--xg-arrow-top', Math.round(top) + 'px');
  }

  function updateAllArrows() {
    toArray(document.querySelectorAll('[data-xg-slider]')).forEach(function (slider) {
      layoutArrows(slider);
      updateArrows(slider);
    });
  }

  // Barre de filtres compacte fixée sous le menu du site.
  function headerBottom() {
    var header = document.querySelector('.shopify-section.section-header') || document.querySelector('header');
    if (!header) return 0;
    return Math.max(0, Math.round(header.getBoundingClientRect().bottom));
  }

  function updateBars() {
    updateAnchors();
    var bars = toArray(document.querySelectorAll('[data-xg-bar]'));
    if (!bars.length) return;
    var top = headerBottom();
    var sliders = toArray(document.querySelectorAll('[data-xg-section]')).filter(function (s) {
      return !s.hidden;
    });
    var last = sliders[sliders.length - 1];
    bars.forEach(function (bar) {
      var source = document.getElementById(bar.getAttribute('data-xg-bar-source'));
      bar.style.setProperty('--xg-bar-top', top + 'px');
      var show = false;
      if (source) {
        var sourceBottom = source.getBoundingClientRect().bottom;
        var lastBottom = last ? last.getBoundingClientRect().bottom : 0;
        show = sourceBottom <= top && lastBottom > top + bar.offsetHeight;
      }
      bar.classList.toggle('is-visible', show);
      if (show) {
        bar.removeAttribute('inert');
        bar.setAttribute('aria-hidden', 'false');
      } else {
        bar.setAttribute('inert', '');
        bar.setAttribute('aria-hidden', 'true');
      }
    });
  }

  // Boutons de prix : lien vers un slider (grisé si le slider est masqué) + repère du slider à l'écran.
  function barHeight() {
    var bar = document.querySelector('[data-xg-bar]');
    return bar ? bar.offsetHeight : 0;
  }

  function updateAnchors() {
    var chips = toArray(document.querySelectorAll('[data-xg-anchor]'));
    if (!chips.length) return;
    var bar = document.querySelector('[data-xg-bar]');
    var line = headerBottom() + (bar ? barHeight() : 0) + 24;
    var currentId = null;
    chips.forEach(function (chip) {
      var target = document.getElementById(chip.getAttribute('data-xg-anchor'));
      var usable = !!target && !target.hidden;
      chip.setAttribute('aria-disabled', usable ? 'false' : 'true');
      if (usable) {
        var rect = target.getBoundingClientRect();
        if (rect.top <= line && rect.bottom > line) currentId = chip.getAttribute('data-xg-anchor');
      }
    });
    chips.forEach(function (chip) {
      if (chip.getAttribute('data-xg-anchor') === currentId) {
        chip.setAttribute('aria-current', 'true');
      } else {
        chip.removeAttribute('aria-current');
      }
    });
  }

  // Une fois le défilement terminé, recale le slider juste sous la barre fixe
  // (le menu du site se cache ou réapparaît pendant le défilement, sa hauteur varie).
  var pendingAnchor = null;
  function correctAnchor() {
    if (!pendingAnchor) return;
    var target = document.getElementById(pendingAnchor.id);
    var bar = document.querySelector('[data-xg-bar]');
    if (!target || pendingAnchor.tries >= 2) {
      pendingAnchor = null;
      return;
    }
    var wanted = (bar ? bar.getBoundingClientRect().bottom : headerBottom()) + 8;
    var delta = Math.round(target.getBoundingClientRect().top - wanted);
    pendingAnchor.tries++;
    if (Math.abs(delta) > 3) {
      window.scrollBy({ top: delta, behavior: 'auto' });
    } else {
      pendingAnchor = null;
    }
  }

  function scrollToAnchor(id) {
    var target = document.getElementById(id);
    if (!target || target.hidden) return;
    var header = document.querySelector('.shopify-section.section-header');
    var headerHeight = header ? header.offsetHeight : 0;
    var targetTop = target.getBoundingClientRect().top + window.pageYOffset;
    // en remontant, le menu du site réapparaît : on le compte dans le décalage
    var goingUp = targetTop < window.pageYOffset;
    var offset = barHeight() + (goingUp ? headerHeight : 0) + 8;
    var pending = { id: id, tries: 0 };
    pendingAnchor = pending;
    setTimeout(function () {
      if (pendingAnchor === pending) pendingAnchor = null;
    }, 2500);
    window.scrollTo({ top: Math.max(0, Math.round(targetTop - offset)), behavior: 'smooth' });
    if (window.history && window.history.replaceState) {
      window.history.replaceState(null, '', '#' + id);
    }
  }

  var settleTimer = null;
  function onPageScroll() {
    updateBars();
    clearTimeout(settleTimer);
    // le menu du site s'anime (apparition / disparition) : on recale la barre une fois l'animation finie
    settleTimer = setTimeout(function () {
      updateBars();
      correctAnchor();
    }, 300);
  }

  function syncChips() {
    toArray(document.querySelectorAll('[data-xg-chip]')).forEach(function (chip) {
      var group = chip.getAttribute('data-xg-group');
      var tag = chip.getAttribute('data-xg-tag');
      var on = !!(state[group] && state[group].indexOf(tag) > -1);
      chip.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var active = activeGroups().length > 0;
    toArray(document.querySelectorAll('[data-xg-reset]')).forEach(function (btn) {
      btn.hidden = !active;
    });
  }

  function apply() {
    var groups = activeGroups();
    var filtering = groups.length > 0;
    var totalVisible = 0;

    toArray(document.querySelectorAll('[data-xg-section]')).forEach(function (section) {
      var visible = 0;
      toArray(section.querySelectorAll('[data-xg-product]')).forEach(function (item) {
        var tags = (item.getAttribute('data-xg-tags') || '').split(' ').filter(Boolean);
        var ok = groups.every(function (g) {
          return state[g].some(function (t) {
            return tags.indexOf(t) > -1;
          });
        });
        item.hidden = !ok;
        if (ok) visible++;
      });
      totalVisible += visible;

      var isEmpty = filtering && visible === 0;
      var message = section.querySelector('[data-xg-empty]');
      if (message) message.hidden = !isEmpty;
      section.classList.toggle('xg-is-empty', isEmpty);
      if (!section.hasAttribute('data-xg-pending')) {
        section.hidden = isEmpty && section.getAttribute('data-xg-hide-empty') === 'true';
      }

      var slider = section.querySelector('[data-xg-slider]');
      var track = section.querySelector('[data-xg-track]');
      if (track) track.scrollLeft = 0;
      if (slider) {
        layoutArrows(slider);
        updateArrows(slider);
      }
    });

    syncChips();
    updateBars();

    toArray(document.querySelectorAll('[data-xg-status]')).forEach(function (status) {
      if (!filtering) {
        status.textContent = '';
        return;
      }
      var text;
      if (totalVisible === 0) {
        text = status.getAttribute('data-xg-text-none') || '';
      } else if (totalVisible === 1) {
        text = status.getAttribute('data-xg-text-one') || '';
      } else {
        text = status.getAttribute('data-xg-text-other') || '';
      }
      status.textContent = text.replace('{count}', totalVisible);
    });
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-xg-anchor]');
    if (link) {
      event.preventDefault();
      scrollToAnchor(link.getAttribute('data-xg-anchor'));
      return;
    }

    var chip = event.target.closest('[data-xg-chip]');
    if (chip) {
      var group = chip.getAttribute('data-xg-group');
      var tag = chip.getAttribute('data-xg-tag');
      if (!state[group]) state[group] = [];
      var index = state[group].indexOf(tag);
      if (index > -1) {
        state[group].splice(index, 1);
      } else {
        state[group].push(tag);
      }
      apply();
      return;
    }

    if (event.target.closest('[data-xg-reset]')) {
      state = {};
      apply();
      return;
    }

    var arrow = event.target.closest('[data-xg-prev], [data-xg-next]');
    if (arrow) {
      var slider = arrow.closest('[data-xg-slider]');
      var track = slider && slider.querySelector('[data-xg-track]');
      if (!track) return;
      var direction = arrow.hasAttribute('data-xg-prev') ? -1 : 1;
      track.scrollBy({ left: direction * track.clientWidth * 0.9, behavior: 'smooth' });
    }
  });

  document.addEventListener(
    'scroll',
    function (event) {
      var track = event.target;
      if (track && track.matches && track.matches('[data-xg-track]')) {
        updateArrows(track.closest('[data-xg-slider]'));
      }
    },
    true
  );

  window.addEventListener('resize', function () {
    updateAllArrows();
    updateBars();
  });
  window.addEventListener('scroll', onPageScroll, { passive: true });

  // Ne garde que les N produits au stock le plus bas (épuisés ignorés), dans l'ordre de la collection.
  function lowStockSection(section) {
    var count = parseInt(section.getAttribute('data-xg-low-stock'), 10);
    var track = section.querySelector('[data-xg-track]');
    if (!count || !track) return;
    var items = toArray(track.children).map(function (item, index) {
      var unlimited = item.getAttribute('data-xg-unlimited') === 'true';
      return { item: item, index: index, unlimited: unlimited, stock: parseInt(item.getAttribute('data-xg-stock'), 10) || 0 };
    });
    var eligible = items.filter(function (entry) {
      return entry.unlimited || entry.stock > 0;
    });
    eligible.sort(function (a, b) {
      var sa = a.unlimited ? Infinity : a.stock;
      var sb = b.unlimited ? Infinity : b.stock;
      if (sa !== sb) return sa < sb ? -1 : 1;
      return a.index - b.index;
    });
    var keep = eligible.slice(0, count).map(function (entry) {
      return entry.item;
    });
    items.forEach(function (entry) {
      if (keep.indexOf(entry.item) === -1) entry.item.parentNode.removeChild(entry.item);
    });
  }

  // Ordre d'affichage : prix croissant / décroissant éventuel, puis nouveautés en premier
  // (produits publiés depuis moins de N jours). Le reste garde l'ordre de la collection.
  // On n'utilise que la propriété CSS "order" : les cartes ne sont JAMAIS déplacées dans la page,
  // car le script d'images du thème (Alpine / Splide) ne se relance pas sur une carte déplacée
  // et ses photos resteraient masquées. Les filtres ne font que masquer : les nouveautés restent devant.
  // Retire ensuite les produits au-delà du nombre maximum.
  function orderSection(section) {
    var track = section.querySelector('[data-xg-track]');
    if (!track) return;
    var mode = section.getAttribute('data-xg-sort');
    var days = parseFloat(section.getAttribute('data-xg-new-days')) || 0;
    var limit = parseInt(section.getAttribute('data-xg-limit'), 10) || 0;
    var nowSec = Date.now() / 1000;
    var entries = toArray(track.children).map(function (item, index) {
      var published = parseInt(item.getAttribute('data-xg-published'), 10);
      return {
        item: item,
        index: index,
        price: parseFloat(item.getAttribute('data-xg-price')) || 0,
        fresh: days > 0 && published > 0 && (nowSec - published) / 86400 <= days,
      };
    });
    if (mode === 'price_asc' || mode === 'price_desc') {
      var sign = mode === 'price_asc' ? 1 : -1;
      entries.sort(function (a, b) {
        return sign * (a.price - b.price) || a.index - b.index;
      });
    }
    var ordered = entries
      .filter(function (e) {
        return e.fresh;
      })
      .concat(
        entries.filter(function (e) {
          return !e.fresh;
        })
      );
    ordered.forEach(function (entry, rank) {
      if (limit && rank >= limit) {
        entry.item.parentNode.removeChild(entry.item);
      } else {
        entry.item.style.order = rank;
      }
    });
    // le navigateur peut "re-caler" le slider sur l'ancien premier produit après un changement d'ordre
    track.style.scrollSnapType = 'none';
    track.scrollLeft = 0;
    setTimeout(function () {
      track.style.scrollSnapType = '';
      track.scrollLeft = 0;
    }, 80);
  }

  // Les collections de plus de 50 produits sont lues par lots de 50 : le premier lot est dans la page,
  // les suivants sont demandés au thème (API de rendu des sections) puis ajoutés au slider.
  function loadMoreProducts(section) {
    var pages = parseInt(section.getAttribute('data-xg-pages'), 10) || 1;
    var page = parseInt(section.getAttribute('data-xg-page'), 10) || 1;
    var wrapper = section.closest('.shopify-section');
    if (!wrapper || section.__xgLoading) return;
    section.__xgLoading = true;
    var sectionId = wrapper.id.replace('shopify-section-', '');
    var requests = [];
    for (var p = page + 1; p <= pages; p++) {
      var url = new URL(window.location.href);
      url.hash = '';
      url.searchParams.set('section_id', sectionId);
      url.searchParams.set('page', p);
      requests.push(
        fetch(url.toString(), { credentials: 'same-origin' })
          .then(function (response) {
            return response.ok ? response.text() : '';
          })
          .catch(function () {
            return '';
          })
      );
    }
    Promise.all(requests).then(function (pagesHtml) {
      var track = section.querySelector('[data-xg-track]');
      pagesHtml.forEach(function (html) {
        if (!html || !track) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        toArray(doc.querySelectorAll('[data-xg-product]')).forEach(function (item) {
          track.appendChild(document.importNode(item, true));
        });
      });
      lowStockSection(section);
      orderSection(section);
      section.removeAttribute('data-xg-pending');
      section.hidden = !(track && track.children.length);
      apply();
      updateAllArrows();
    });
  }

  function init() {
    toArray(document.querySelectorAll('[data-xg-section]')).forEach(function (section) {
      if (!section.hasAttribute('data-xg-pending')) {
        lowStockSection(section);
        orderSection(section);
      } else if (!(window.Shopify && window.Shopify.designMode)) {
        loadMoreProducts(section);
      }
    });
    apply();
    updateAllArrows();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', function () {
    updateAllArrows();
    updateBars();
  });
  document.addEventListener('shopify:section:load', init);
})();
